import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';

/**
 * Reusable empty state component for when lists or views have no data.
 *
 * @param {React.ElementType} icon - MUI icon component to display (default: InboxIcon)
 * @param {string} title - Primary message (e.g., "No surveys yet")
 * @param {string} description - Secondary descriptive text (optional)
 * @param {string} actionLabel - Button label (optional, renders action button if provided)
 * @param {function} onAction - Button click handler (optional)
 * @param {object} sx - Additional sx styles for the container (optional)
 */
function EmptyState({
  icon: IconComponent = InboxIcon,
  title = 'No data yet',
  description,
  actionLabel,
  onAction,
  sx = {},
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 6,
        px: 3,
        textAlign: 'center',
        ...sx,
      }}
    >
      <IconComponent
        sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }}
      />
      <Typography variant="h6" color="text.secondary" gutterBottom>
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" color="text.disabled" sx={{ mb: actionLabel ? 3 : 0, maxWidth: 400 }}>
          {description}
        </Typography>
      )}
      {actionLabel && onAction && (
        <Button variant="contained" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </Box>
  );
}

export default EmptyState;
